// extracted by mini-css-extract-plugin
module.exports = {"languageLink":"Language__languageLink--9vA","icon":"Language__icon--3_y","language":"Language__language--Htd"};